<template>
 <div>
   <timer-web-component 
   :tool.prop="{...tool}" 
   :user="user && user.uid" 
   :focus.prop="{...focus}"
   :set-tracker.prop="(p) => $store.dispatch('tools/setTrackerInTool', p)"
   >
    <template v-slot:default>
      THIS IS TRACKING
    </template>
   </timer-web-component>
  </div>
</template>

<script>

import Vue from "vue"
import moment from "moment"

window.Vue = Vue
window.moment = moment
const TimerWebComponent = () => import("./wc/timer-web-component")

Vue.use(TimerWebComponent)

export default {
  name: 'toolwindow-default',
  components: {
  },
  props: {
    tool: {
      type: Object,
      required: false,
      default:()=>{}
    },
    focus: {
      type: Object,
      required: false,
      default: () => {
      }
    },
    user: {
      type: Object,
      required: false,
      default: () => {}
    },
    typeaheadApps: {
      type: Array,
      default: () => ['Maps','Calculator']
    },
    idprop: {
      type: String
    },
    showTracking: {
      type: Boolean
    }
  },
  methods:{
  },
  computed: {
  },
  data: function() {
    return {
    }
  },
  mounted(){
  }
}
</script>
<style lang="scss" module>
  @import './style.module.scss';
</style>
<style scoped>
  .notepad {
    background-color: rgb(255, 242, 204);
    border-radius: 5px;
    width: 100%;
    height: 125px;
  }
  .card-body {
    overflow-y: auto;
  }
</style>
